import * as z from "zod"

export const OidcProviderDbModel = z.object({
  id: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  name: z.string(),
  issuer: z.string(),
  clientId: z.string(),
  clientSecret: z.string(),
  authorizationEndpoint: z.string().nullish(),
  tokenEndpoint: z.string().nullish(),
  userinfoEndpoint: z.string().nullish(),
  jwksUri: z.string().nullish(),
  introspectionEndpoint: z.string().nullish(),
  scopes: z.string().array(),
  audience: z.string().nullish(),
  prompt: z.string().nullish(),
  usernameClaim: z.string(),
  emailClaim: z.string(),
  nameClaim: z.string(),
  groupClaim: z.string(),
  enabled: z.boolean(),
  autoDiscovery: z.boolean(),
})
